import { types } from './mutation-types';

export const registration = {
  namespaced: true,
  state: {
    registrationUsername: '',
    registrationPassword: '',
    isRegistrationAgreementsChecked: false,
  },
  getters: {},
  mutations: {
    [types.SET_REGISTRATION_USERNAME](state, newRegistrationUsername) {
      state.registrationUsername = newRegistrationUsername;
    },
    [types.SET_REGISTRATION_EMAIL](state, newRegistrationPassword) {
      state.registrationPassword = newRegistrationPassword;
    },
    [types.SET_REGISTRATION_AGREEMENTS](state, isAgreementChecked) {
      state.isRegistrationAgreementsChecked = isAgreementChecked;
    },
  },
  actions: {
    handleRegistrationUsernameChanged({ commit }, newRegistrationUsername) {
      commit(types.SET_REGISTRATION_USERNAME, newRegistrationUsername);
    },
    handleRegistrationPasswordChanged({ commit }, newRegistrationPassword) {
      commit(types.SET_REGISTRATION_EMAIL, newRegistrationPassword);
    },
    handleRegistrationAgreementsChanged({ commit }, isRegistrationAgreemetsChecked) {
      commit(types.SET_REGISTRATION_AGREEMENTS, isRegistrationAgreemetsChecked);
    },
  },
};
